export default [
  { path: '/base/product', name: 'BaseProduct', component: () => import(/* webpackChunkName: "base-product" */ './index.vue') }
]